// extracted by mini-css-extract-plugin
export default {"melodyVideo":"tL-z","isFullWidth":"uL-z","landingPageVideo":"vL-z","play":"wL-z","iframeVideo":"xL-z","playHidden":"yL-z","fullwidth":"zL-z"};